<template>
	<div class="tcp-page tcp-info">
		<section class="tcp-info__hero">
			<p class="tcp-kicker">Support</p>
			<h1>Frequently Asked Questions</h1>
			<p>Find answers to our most common questions below. Can't find what you're looking for? <router-link to="/contact">Contact us</router-link>.</p>
		</section>

		<section class="tcp-info__body">
			<div v-for="group in sections" :key="group.section" class="tcp-faq__group">
				<h2>{{ group.section }}</h2>
				<div
					v-for="item in group.items"
					:key="item.id"
					class="tcp-faq__item"
					:class="{ 'is-open': isOpen(item.id) }"
				>
					<button type="button" @click="toggle(item.id)">
						<span>{{ item.question }}</span>
						<i class="fa fa-chevron-down"></i>
					</button>
					<p v-if="isOpen(item.id)">{{ item.answer }}</p>
				</div>
			</div>
			<p v-if="!loading && !sections.length" class="tcp-empty">No questions published yet.</p>
		</section>
	</div>
</template>

<script>
export default {
	data() {
		return {
			sections: [],
			openIds: [],
			loading: true
		}
	},
	mounted() {
		axios.get(tools.url('/api/store/faqs')).then((response) => {
			this.sections = response.data || []
			this.loading = false
		}).catch(() => {
			this.loading = false
		})
	},
	methods: {
		isOpen(id) {
			return this.openIds.indexOf(id) !== -1
		},
		toggle(id) {
			const index = this.openIds.indexOf(id)
			if (index === -1) this.openIds.push(id)
			else this.openIds.splice(index, 1)
		}
	}
}
</script>
